const areasIniciales = [
  // 🏥 Urgencias
  { name: "Sala de Reanimación", grupo: "Urgencias" },
  { name: "Sala de Procedimientos", grupo: "Urgencias" },
  { name: "Sala de Observación", grupo: "Urgencias" },
  { name: "Triage", grupo: "Urgencias" },
  { name: "Área de Trauma", grupo: "Urgencias" },

  // 🧑‍⚕️ Consulta Externa
  { name: "Consulta Médica General", grupo: "Consulta Externa" },
  { name: "Consulta Especializada", grupo: "Consulta Externa" },
  { name: "Odontología", grupo: "Consulta Externa" },
  { name: "Laboratorio Clínico", grupo: "Consulta Externa" },
  { name: "Rayos X", grupo: "Consulta Externa" },
  { name: "Ecografía", grupo: "Consulta Externa" },
  { name: "Optometría", grupo: "Consulta Externa" },
  { name: "Fisioterapia", grupo: "Consulta Externa" },
  { name: "Vacunación", grupo: "Consulta Externa" },
  { name: "Farmacia", grupo: "Consulta Externa" },
  { name: "Toma de Muestras", grupo: "Consulta Externa" },

  // 🛏️ Hospitalización
  { name: "Pediatría", grupo: "Hospitalización" },
  { name: "Medicina Interna", grupo: "Hospitalización" },
  { name: "Cirugía", grupo: "Hospitalización" },
  { name: "Ginecología", grupo: "Hospitalización" },
  { name: "UCI Adultos", grupo: "Hospitalización" },
  { name: "UCI Neonatal", grupo: "Hospitalización" },
  { name: "UCI Pediátrica", grupo: "Hospitalización" },
  { name: "Sala de Partos", grupo: "Hospitalización" },
  { name: "Sala de Cirugía", grupo: "Hospitalización" },
  { name: "Central de Esterilización", grupo: "Hospitalización" },
  { name: "Hospitalización General", grupo: "Hospitalización" },

  // 👁️ Observación
  { name: "Observación Pediátrica", grupo: "Observación" },
  { name: "Observación Adultos", grupo: "Observación" },
  { name: "Observación Materna", grupo: "Observación" },
  { name: "Observación Posoperatoria", grupo: "Observación" },
  { name: "Sala de Espera Observación", grupo: "Observación" },
];

export default areasIniciales;
